import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import LockIcon from '@mui/icons-material/Lock';
import { IconButton, InputAdornment, Tooltip } from '@mui/material';
import { useNotify, useTranslate } from 'react-admin';

type Props = {
  value?: string;
  disabled?: boolean;
  readOnly?: boolean;
};

export const InputStateAdornment = ({ value, disabled, readOnly }: Props) => {

  const notify = useNotify();
  const translate = useTranslate();

  if (disabled) {

    return (
      <InputAdornment position="end">
        <Tooltip title={translate('general.text.disabled')}>
          <LockIcon fontSize="small" aria-hidden />
        </Tooltip>
      </InputAdornment>
    );

  }

  if (readOnly) {

    return (
      <InputAdornment position="end">
        <Tooltip title={translate('general.text.copy')}>
          <IconButton
            size="small"
            edge="end"
            aria-label={translate('general.text.copy')}
            onClick={async () => {

              if (!value) return;
              await navigator.clipboard.writeText(String(value));
              notify('ra.notification.copied', { type: 'info' });

            }}
          >
            <ContentCopyIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </InputAdornment>
    );

  }

  return null;

};
